<template>
  <div class="_title" :class="{'is_back_image': isBackImage}">
    <slot></slot>
    <span>{{subtext}}</span>
  </div>
</template>

<script>
export default {
  props: {
    subtext: {
      type: String,
      default: '',
    },
    isBackImage: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  color: $white;
  background-color: #5c6d99;
  font-size: 16px;
  padding: 10px 0 10px 30px;
  span {
    font-size: 13px;
    margin-left: 10px;
  }
}
.is_back_image {
  background-image: url('/img/h-bg-03.png');
  background-size: 100%;
}
@media screen and  (max-width: $tabletWidth) {
  ._title {
    padding-left: 20px;
  }
}
</style>
